import { NavLink } from 'react-router-dom';

import styled from 'styled-components';

export const StyledNavLink = styled(NavLink)`
  font-size: var(--fs-sm);
  color: var(--c-text-muted);
  transition: color 0.2s ease;

  &:hover {
    color: var(--c-text);
  }

  &.active {
    color: var(--c-accent);
  }
`;
